import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getToken } from '../utils/auth';
import AdminServiceForm from '../components/AdminServiceForm';

const AdminServices = () => {
  const [items, setItems] = useState([]);
  const [editingItem, setEditingItem] = useState(null);

  const fetchItems = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/services`);
      setItems(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      console.error('Failed to fetch services', e);
      setItems([]);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this service?')) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/services/${id}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      fetchItems();
    } catch (e) {
      console.error('Delete failed', e);
      alert('Delete failed');
    }
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Services Manager</h2>
      </div>

      <AdminServiceForm onSaved={() => { fetchItems(); setEditingItem(null); }} editingItem={editingItem} />

      <hr />

      <h4 className="mt-4">Existing Services</h4>
      <div className="row g-3">
        {items.map((svc) => (
          <div className="col-md-6 col-lg-4" key={svc.id}>
            <div className="card h-100">
              {svc.image && (
                <img
                  src={`${process.env.REACT_APP_API_URL}/uploads/${svc.image}`}
                  alt={svc.title}
                  className="card-img-top"
                  style={{ height: '200px', objectFit: 'cover' }}
                />
              )}
              <div className="card-body d-flex flex-column">
                <h5 className="fw-bold mb-1">{svc.title}</h5>
                <div className="text-muted small mb-2">{svc.link}</div>
                {svc.price !== null && svc.price !== undefined && svc.price !== '' && (
                  <div className="mb-2" style={{ fontWeight: 700 }}>
                    Price: {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(svc.price))}
                  </div>
                )}
                <p className="flex-grow-1 small mb-3">{svc.description}</p>
                <div className="mt-auto">
                  <button className="btn btn-primary btn-sm me-2" onClick={() => setEditingItem(svc)}>Edit</button>
                  <button className="btn btn-danger btn-sm" onClick={() => handleDelete(svc.id)}>Delete</button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminServices;
